<span id="{{Id}}" [ngStyle]="getColor()">{{displayString}}</span>
